import React from 'react';
import { SecondaryButton } from '@gjensidige/core-buttons';
import { text } from '../../../../utils/text';
import style from './personvern-info-button.module.less';
import classNames from 'classnames';
import utils from '@gjensidige/core-utilities-css';
import { Action } from '../../../../utils/types';
import { useGlobalDispatch } from '../../../../context/GlobalContext';
export const PersonvernInfoButton = () => {
    const dispatch = useGlobalDispatch();
    const onClick = () => {
        dispatch({ type: Action.SHOW_PERSONVERN_MODAL, state: { show: true } });
    };
    return (React.createElement(SecondaryButton, { onClick: onClick, noPadding: true, className: classNames(utils['font-weight-medium'], style.personvern) }, text.PERSONVERN_INFO_MODAL.BUTTON.no));
};
